<template>
    <div id="dataGridEmargement" ref="content" style="height:auto;">
        <!-- {{ dataEmargement }} -->
        <table  style="font-family: Arial, Helvetica, sans-serif;">
            <tr><td style="background-color: darkgrey;text-align:center;padding:8px 0;" class="text-center py-4">{{ salle }} / {{ changeFormatDate() }}</td></tr>
            <tr>
                <td>
                    <table class="text-center" style="text-align:center" width="100%">
                        <tr>
                            <td style="padding:4px 0;background-color: rgb(232, 226, 226);">Lundi</td>
                            <td style="padding:4px 0;background-color: rgb(232, 226, 226);">Mardi</td>
                            <td style="padding:4px 0;background-color: rgb(232, 226, 226);">Mercredi</td>
                            <td style="padding:4px 0;background-color: rgb(232, 226, 226);">Jeudi</td>
                            <td style="padding:4px 0;background-color: rgb(232, 226, 226);">Vendredi</td>
                            <td style="padding:4px 0;background-color: rgb(232, 226, 226);">Samedi</td>
                            <td style="padding:4px 0;background-color: rgb(232, 226, 226);">Dimanche</td>
                        </tr>
                        <tr>
                        <!-- <tr v-for="(item,i) in dataEmargement" :key="i"> -->
                            
                            <td style="vertical-align: top;" v-for="(day,cle) in ['Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi','Dimanche']" :key="cle">
                                <!-- <table style="vertical-align: top; display: inline-table;" width="100%" >
                                    <tr>
                                    <td> -->
                                        
                                        <table style="vertical-align: top;" v-for="(el,e) in setCreneau(day,dataEmargement)[day]" :key="e"  width="100%">
                                            <!-- <span > -->
                                            <tr  style="background-color: rgb(176, 173, 173);">
                                                <td style="padding:4px 0;">{{ el.categorie_libelle }}</td>
                                            </tr>
                                            <tr><td style="background-color: rgb(246, 239, 239);padding:4px 0" class="text-left pl-2">{{ el.creneau }}</td></tr>
                                            <tr><td style="background-color: rgb(246, 239, 239);padding:4px 0" class="text-left pl-2">{{el.user_libelle?el.user_libelle.replace(","," / "):"non attribué"}}</td></tr>
                                            <tr>
                                                <td style="text-align: left;border: 0 !important;" class="text-left">
                                                    <table width="100%" style="border-collapse:collapse;border-spacing:0;text-align: left; ">
                                                        <tr style="font-size: 12px;" class="text-left">
                                                            <td style="min-width: 25%;padding:3px;">{{ !el.licencie_creneau.length?"Pas encore d'inscrits":"" }}</td>
                                                            <td v-for="j in [0,1,2,3,4]" :key="j" style="text-align:center;min-width:20px ;">{{ getSpecificDayInMonth((cle))[j] }}</td>
                                                            <!-- <td v-for="j in [0,1,2,3,4]" :key="j" style="text-align:center;min-width:20px ;">{{ getSpecificDayInMonth((cle+1)%7)[j] }}</td> -->
                                                        </tr>
                                                        <tr v-for="(value,t) in el.licencie_creneau" :key="t">
                                                            <td style="min-width: 25% !important;font-size: 12px !important;padding:3px;" class="text-left pl-2">{{ value.prenom }}<br>{{ value.nom }}</td>
                                                            <td style="text-align:center;" v-for="j in [0,1,2,3,4]" :key="j">{{ el.emargement_licencie[`${date}-${getSpecificDayInMonth((cle))[j]}`]?.find(lic=>lic.ref==value.ref_licencie && lic.presence==true)!=undefined?"&#9989;":"" }}</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                            <!-- </span> -->
                                        </table>
                                    <!-- </td>
                                    </tr>
                                </table> -->
                            </td>
                            <!-- <td>
                                <table width="100%">
                                    <tr v-for="(el,e) in item.creneaux" :key="e">
                                    <td v-if="el.jour=='Mardi'">
                                        
                                        <table  width="100%">
                                            <tr style="background-color: rgb(176, 173, 173);">
                                                <td>{{ item.categorie_libelle }}</td>
                                            </tr>
                                            <tr><td style="background-color: rgb(246, 239, 239);" class="text-left pl-2">{{ el.creneau }}</td></tr>
                                            <tr>
                                                <td class="text-left">
                                                    <table width="100%" border="1" style="border-collapse:collapse;border-spacing:0">
                                                        <tr style="font-size: 12px;;" class="text-left">
                                                            <td></td>
                                                            <td v-for="j in [0,1,2,3,4]" :key="j" style="text-align:center;min-width:20px ;">{{ getSpecificDayInMonth(2)[j] }}</td>
                                                        </tr>
                                                        <tr v-for="(value,t) in el.licencie_creneau" :key="t">
                                                            <td style="min-width: 150px;font-size: 12px;;" class="text-left pl-2">{{ value.prenom }}<br>{{ value.nom }}</td>
                                                            <td style="text-align:center;" v-for="j in [0,1,2,3,4]" :key="j">{{ el.emargement_licencie[`${date}-${getSpecificDayInMonth(2)[j]}`]?.find(lic=>lic.ref==value.ref_licencie && lic.presence==true)!=undefined?"&#9989;":"" }}</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                    </tr>
                                </table>
                            </td>
                            <td>
                                <table width="100%">
                                    <tr v-for="(el,e) in item.creneaux" :key="e">
                                    <td v-if="el.jour=='Mercredi'">
                                        
                                        <table  width="100%">
                                            <tr style="background-color: rgb(176, 173, 173);">
                                                <td>{{ item.categorie_libelle }}</td>
                                            </tr>
                                            <tr><td style="background-color: rgb(246, 239, 239);" class="text-left pl-2">{{ el.creneau }}</td></tr>
                                            <tr>
                                                <td class="text-left">
                                                    <table width="100%" border="1" style="border-collapse:collapse;border-spacing:0">
                                                        <tr style="font-size: 12px;;" class="text-left">
                                                            <td></td>
                                                            <td v-for="j in [0,1,2,3,4]" :key="j" style="text-align:center;min-width:20px ;">{{ getSpecificDayInMonth(3)[j] }}</td>
                                                        </tr>
                                                        <tr v-for="(value,t) in el.licencie_creneau" :key="t">
                                                            <td style="min-width: 150px;font-size: 12px;;" class="text-left pl-2">{{ value.prenom }}<br>{{ value.nom }}</td>
                                                            <td style="text-align:center;" v-for="j in [0,1,2,3,4]" :key="j">{{ el.emargement_licencie[`${date}-${getSpecificDayInMonth(3)[j]}`]?.find(lic=>lic.ref==value.ref_licencie && lic.presence==true)!=undefined?"&#9989;":"" }}</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                    </tr>
                                </table>
                            </td>
                            <td>
                                <table width="100%">
                                    <tr v-for="(el,e) in item.creneaux" :key="e">
                                    <td v-if="el.jour=='Jeudi'">
                                        
                                        <table  width="100%">
                                            <tr style="background-color: rgb(176, 173, 173);">
                                                <td>{{ item.categorie_libelle }}</td>
                                            </tr>
                                            <tr><td style="background-color: rgb(246, 239, 239);" class="text-left pl-2">{{ el.creneau }}</td></tr>
                                            <tr>
                                                <td class="text-left">
                                                    <table width="100%" border="1" style="border-collapse:collapse;border-spacing:0">
                                                        <tr style="font-size: 12px;;" class="text-left">
                                                            <td></td>
                                                            <td v-for="j in [0,1,2,3,4]" :key="j" style="text-align:center;min-width:20px ;">{{ getSpecificDayInMonth(4)[j] }}</td>
                                                        </tr>
                                                        <tr v-for="(value,t) in el.licencie_creneau" :key="t">
                                                            <td style="min-width: 150px;font-size: 12px;;" class="text-left pl-2">{{ value.prenom }}<br>{{ value.nom }}</td>
                                                            <td style="text-align:center;" v-for="j in [0,1,2,3,4]" :key="j">{{ el.emargement_licencie[`${date}-${getSpecificDayInMonth(4)[j]}`]?.find(lic=>lic.ref==value.ref_licencie && lic.presence==true)!=undefined?"&#9989;":"" }}</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                    </tr>
                                </table>
                            </td>
                            <td>
                                <table width="100%">
                                    <tr v-for="(el,e) in item.creneaux" :key="e">
                                    <td v-if="el.jour=='vendredi'">
                                        
                                        <table  width="100%">
                                            <tr style="background-color: rgb(176, 173, 173);">
                                                <td>{{ item.categorie_libelle }}</td>
                                            </tr>
                                            <tr><td style="background-color: rgb(246, 239, 239);" class="text-left pl-2">{{ el.creneau }}</td></tr>
                                            <tr>
                                                <td class="text-left">
                                                    <table width="100%" border="1" style="border-collapse:collapse;border-spacing:0">
                                                        <tr style="font-size: 12px;;" class="text-left">
                                                            <td></td>
                                                            <td v-for="j in [0,1,2,3,4]" :key="j" style="text-align:center;min-width:20px ;">{{ getSpecificDayInMonth(2)[j] }}</td>
                                                        </tr>
                                                        <tr v-for="(value,t) in el.licencie_creneau" :key="t">
                                                            <td style="min-width: 150px;font-size: 12px;;" class="text-left pl-2">{{ value.prenom }}<br>{{ value.nom }}</td>
                                                            <td style="text-align:center;" v-for="j in [0,1,2,3,4]" :key="j">{{ el.emargement_licencie[`${date}-${getSpecificDayInMonth(2)[j]}`]?.find(lic=>lic.ref==value.ref_licencie && lic.presence==true)!=undefined?"&#9989;":"" }}</td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                    </tr>
                                </table>
                            </td>
                            <td>
                                <table width="100%">
                                    <tr v-for="(el,e) in item.creneaux" :key="e">
                                    <td v-if="el.jour=='Samedi'">{{ item.categorie_libelle }}</td>
                                    </tr>
                                </table>
                            </td>
                            <td>
                                <table width="100%">
                                    <tr v-for="(el,e) in item.creneaux" :key="e">
                                    <td v-if="el.jour=='Dimanche'">{{ item.categorie_libelle }}</td>
                                    </tr>
                                </table>
                            </td> -->
                             
                        </tr>
                    </table>
                </td>
            </tr>
        </table>
    </div>
</template>
<script>
import moment from 'moment';
// import html2pdf from "html2pdf.js";
export default {
    name: "EmargementDataGrid",
    data:()=>({
        // year:moment(date).format("YYYY"),
        // month:moment(date).format("MM"),
        htmlString: null,
        jourArray : ['Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi','Dimanche']
    }),
    props: {
        dataEmargement:{
            type: Array
        },
        salle:{
            type:String
        },
        date:{
            type:String
        }
    },
    methods: {
    setCreneau(day,data){
// console.log("item_creneau",data)
        const groupedByDay = data.flatMap(categorie => 
        // const groupedByDay =    data.map(creneau => ({
        categorie.creneaux.map(creneau => ({
        categorie_libelle: categorie.categorie_libelle,
        user_libelle: creneau.user_libelle,
        jour: creneau.jour,
        creneau: creneau.creneau,
        description: creneau.description,
        licencie_creneau: creneau.licencie_creneau || [],
        emargement_licencie: creneau.emargement_licencie || {}
    }))
)
.reduce((acc, curr) => {
    if (!acc[curr.jour]) {
        acc[curr.jour] = [];
    }
    acc[curr.jour].push(curr);
    return acc;
}, {});

    //    console.log("groupedByDay===>",groupedByDay)
        return groupedByDay
        },
    //     async imprimerEmargement(){
    // //         const ComponentClass = Vue.extend(cardClub);
    // //   const componentInstance = new ComponentClass().$mount();
    // //   await Vue.nextTick();
    //   this.htmlString = this.$refs.content;
    // //   this.htmlString = componentInstance.$refs.content;
    // //   this.htmlString = componentInstance.$refs.content;

    //         const element = this.htmlString;
    //         const opt = {
    //             margin: 0,
    //             filename: "carte-emargement.pdf",
    //             image: { type: "jpeg", quality: 0.98 },
    //             html2canvas: { scale: 2 },
    //             jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    //         };

    //         html2pdf(element, opt);
    //     },
        changeFormatDate(){
            return moment(this.date,"YYYY-MM").locale("fr").format("MMMM YYYY")
        },
        getSpecificDayInMonth(dayOfWeekCustom) {
            // console.log("this.date",this.date)
            let year = moment(this.date,"YYYY-MM").year()
            let month = moment(this.date,"YYYY-MM").month()+1
            // let year = moment(this.date,"YYYY-MM").format("YYYY")
            // let month = moment(this.date,"YYYY-MM").format("MM")
            // console.log("this.date year",year,"this.date month",month)
            // console.log(this.date)
  // Créer un tableau pour stocker les dates correspondantes
  let dates = [];
  
  // Créer une date pour le premier jour du mois
  const date = new Date(year, month - 1, 1);
//   console.log(`Year: ${year}, Month: ${month}, Start Date: ${new Date(year, month - 1, 1)}`)
  // Parcourir tous les jours du mois
//   console.log("date.getMonth()==>",date.getMonth())
  while (date.getMonth() === month - 1) {
// const lastDay = new Date(year, month, 0).getDate(); // Dernier jour du mois
// while (date.getDate() <= lastDay) {
    // Vérifier si le jour correspond (0=Dimanche, 1=Lundi, ..., 6=Samedi)
   
    const adjustedDay = (date.getDay() - 1 + 7) % 7;
    // const adjustedDay = (date.getDay() - 1 + 7) % 7 || 7;
    // console.log("adjustedDay==>",adjustedDay,"dayOfWeekCustom==>",dayOfWeekCustom)
    // console.log("dt",date)
    if (adjustedDay === dayOfWeekCustom ) {

        // let dt = new Date(date)
      dates.push(moment(date,"LLLL").format("DD"));
    //   dates.push(new Date(date).toISOString().split('T')[0]);
    }
    
    // Passer au jour suivant
    // date.setDate(adjustedDay + 1);
    date.setDate(date.getDate() + 1);
  }
//   console.log("dates===>",dates)
//   dates = dates.map(el=>moment(el).format("DD"))
  return dates;
}
    },
}
</script>
<style>
     #dataGridEmargement table tr td {
      border: 1px solid black;
    }
</style>
<style scoped>
.v-data-table > .v-data-table__wrapper > table > thead > tr > th, td
{
    width: 500px !important;
}
</style>